module.exports = __webpack_public_path__ + "img/kj6.d7f88adf.png";